import React from 'react';
import { OverlayTrigger } from 'ui';
import { useUsers } from 'hooks/users/queries';
import CustomPopover from './CustomPopover';
import CoderInfo from './CoderInfo';

const CoderOverlay = ({ coders, projectId, selected, children }) => {
  // Fetch all user data using the useUsers hook
  const userIds = (coders || []).map(coder => coder.user_id);
  const { userMap } = useUsers(userIds, projectId);

  if ((coders || []).length === 0)
    return children;

  // Map users to coders
  const codersWithUsers = coders.map(coder => ({
    coder,
    user: userMap[coder.user_id],
  }));

  const tooltip = (
    <CustomPopover>
      {codersWithUsers.map(({ coder, user }, index) => (
        <CoderInfo
          key={index}
          coder={coder}
          user={user}
          selected={selected}
          index={index}
        />
      ))}
    </CustomPopover>
  );

  return (
    <OverlayTrigger
      delayShow={500}
      delayHide={0}
      placement="bottom"
      overlay={tooltip}
    >
      {children}
    </OverlayTrigger>
  );
};

export default CoderOverlay;